// test25
(25 && 0);
